import type { HighlightsListItem } from '@hotjar/webapp/domains/highlights/model';

type CurrentIndex = number | null;

interface UseKeybindingsProps {
  showPrevious: (currentIndex: CurrentIndex) => void;
  showNext: (currentIndex: CurrentIndex) => void;
  handleKeyDown: (event: React.KeyboardEvent<HTMLInputElement>) => void;
}

export const useKeybindings = (
  selectedHighlightIndex: CurrentIndex,
  setSelectedHighlightId: React.Dispatch<React.SetStateAction<string | null>>,
  highlightsList: { items: HighlightsListItem[] } | undefined,
): UseKeybindingsProps => {
  const showPrevious = (currentIndex: number | null) => {
    if (highlightsList && currentIndex !== null && currentIndex > 0) {
      setSelectedHighlightId(highlightsList.items[currentIndex - 1].id);
    }
  };

  const showNext = (currentIndex: number | null) => {
    if (highlightsList && currentIndex !== null && currentIndex < highlightsList.items.length - 1) {
      setSelectedHighlightId(highlightsList.items[currentIndex + 1].id);
    }
  };

  const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (!(event.target instanceof HTMLTextAreaElement) || event.target.value === '') {
      switch (event.key) {
        case 'ArrowLeft':
          showPrevious(selectedHighlightIndex);
          break;
        case 'ArrowRight':
          showNext(selectedHighlightIndex);
          break;
        case 'Esc':
          setSelectedHighlightId(null);
          break;
        default:
          break;
      }
    }
  };

  return { showPrevious, showNext, handleKeyDown };
};
